import { BaseAPI } from './BaseAPI.js'
import { Plugin } from '../types/index.js'

export default class PluginsApi extends BaseAPI<Plugin> {
  override get resource(): string {
    return '/plugins'
  }
}
